import { SkeletonTypography, SkeletonWrapper } from '@core/component';
import { ETypographyVariant } from '@core/type';

export const SkeletonForecastedDelivery = ({ isActive }: { isActive: boolean }) => {
  return (
    <SkeletonWrapper>
      {isActive ? (
        <>
          <SkeletonTypography variant={ETypographyVariant.H4} marginBottom={'8px'} />
          <SkeletonTypography variant={ETypographyVariant.CAPTION3} marginBottom={'16px'} />
          <SkeletonTypography variant={ETypographyVariant.BODY2} marginBottom={'4px'} />
          <SkeletonTypography variant={ETypographyVariant.BODY2} marginBottom={'4px'} />
          <SkeletonTypography variant={ETypographyVariant.BODY2} marginBottom={'18px'} />
          <SkeletonTypography variant={ETypographyVariant.H4} />
        </>
      ) : (
        <>
          <SkeletonTypography variant={ETypographyVariant.H4} marginBottom={'8px'} />
          <SkeletonTypography variant={ETypographyVariant.CAPTION3} marginBottom={'18px'} />
          <SkeletonTypography variant={ETypographyVariant.H4} />
        </>
      )}
    </SkeletonWrapper>
  );
};
